import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isObjectArray } from '../../../utilities/utilityFunctions';
import { hideMenu, selectApplicantSorterDetail, setSortItem, toggleAscending, toggleMenu } from './reducerSlices/applicantSorterSlice';

function ApplicantSorter(props) {
    const dispatch = useDispatch();
    const applicantSorterDetail = useSelector(selectApplicantSorterDetail);

    const sortByContainerRef = useRef(null);

    useEffect(() => {
        if (applicantSorterDetail.open && sortByContainerRef && sortByContainerRef.current) {
            sortByContainerRef.current.focus();
        }
    });

    let _sortByList;
    if (isObjectArray(applicantSorterDetail.sortByItems)) {
        if (applicantSorterDetail.sortByItems.length > 0) {
            _sortByList = applicantSorterDetail.sortByItems.map((sortByItem, index) => (
                <li
                    className="sort-by-menu-item"
                    onClick={(e) => onSortItemClicked(e, sortByItem.value, sortByItem.text)}>
                    {sortByItem.text}
                </li>
            ));
        }
    }

    const onBlur = (e) => {
        dispatch(hideMenu());
    };

    const onSorted = (e) => {
        dispatch(toggleAscending(!applicantSorterDetail.ascending));
        props.onSorted && props.onSorted(applicantSorterDetail.sortBy, !applicantSorterDetail.ascending);
    };

    const onSortItemClicked = (e, value, text) => {
        dispatch(setSortItem({
            sortByText: text,
            sortBy: value,
            open: false
        }));
        props.onSorted && props.onSorted(value, applicantSorterDetail.ascending);
    };

    const toggle = () => {
        dispatch(toggleMenu(!applicantSorterDetail.open));
    };

    return (
        <div className="sort-by-container">
            <div>
                <span className="sort-by" onClick={(e) => toggle()}>{applicantSorterDetail.sortByText}</span>
                {applicantSorterDetail.open ? <div className="sort-by-menu"
                    ref={sortByContainerRef}
                    tabIndex={-1}
                    onBlur={(e) => onBlur(e)}>
                    <ul className="sort-by-menu-items">
                        {_sortByList}
                    </ul>
                </div> : <></>}
            </div>
            <span className="sort-button" onClick={(e) => onSorted(e)}><i className={applicantSorterDetail.ascending ? "fa fa-chevron-down" : "fa fa-chevron-up"}></i></span>
        </div>
    );
}

export default ApplicantSorter;